export const initialTableData = [
  {
    oshma: "RTSH",
    adresa: "Test Adresa",
    telefoni: "06924234234",
    emaili: "test@test.com",
  },
  {
    oshma: "Tch",
    adresa: "Test Adresa",
    telefoni: "06924234234",
    emaili: "test@test.com",
  },
  {
    oshma: "RTSH",
    adresa: "Test Adresa",
    telefoni: "06924234234",
    emaili: "test@test.com",
  },
  {
    oshma: "Tch",
    adresa: "Test Adresa",
    telefoni: "06924234234",
    emaili: "test@test.com",
  },
  {
    oshma: "RTSH",
    adresa: "Test Adresa",
    telefoni: "06924234234",
    emaili: "test@test.com",
  },
  {
    oshma: "Tch",
    adresa: "Test Adresa",
    telefoni: "06924234234",
    emaili: "test@test.com",
  },
  {
    oshma: "RTSH",
    adresa: "Test Adresa",
    telefoni: "06924234234",
    emaili: "test@test.com",
  },
  {
    oshma: "Tch",
    adresa: "Test Adresa",
    telefoni: "06924234234",
    emaili: "test@test.com",
  },
  {
    oshma: "RTSH",
    adresa: "Test Adresa",
    telefoni: "06924234234",
    emaili: "test@test.com",
  },
  {
    oshma: "Tch",
    adresa: "Test Adresa",
    telefoni: "06924234234",
    emaili: "test@test.com",
  },
  {
    oshma: "RTSH",
    adresa: "Test Adresa",
    telefoni: "06924234234",
    emaili: "test@test.com",
  },
  {
    oshma: "Tch",
    adresa: "Test Adresa",
    telefoni: "06924234234",
    emaili: "test@test.com",
  },
  {
    oshma: "RTSH",
    adresa: "Test Adresa",
    telefoni: "06924234234",
    emaili: "test@test.com",
  },
  {
    oshma: "Tch",
    adresa: "Test Adresa",
    telefoni: "06924234234",
    emaili: "test@test.com",
  },
];

export const imageDataGraphList = [
  {
    url: "https://images.unsplash.com/photo-1523413651479-597eb2da0ad6",
    label: "Image 1",
  },
  {
    url: "https://images.unsplash.com/photo-1551963831-b3b1ca40c98e?w=164&h=164&fit=crop&auto=format&dpr=2",
    label: "Image 2",
  },
  {
    url: "https://images.unsplash.com/photo-1516802273409-68526ee1bdd6?w=164&h=164&fit=crop&auto=format&dpr=2",
    label: "Image 3",
  },
  {
    url: "https://images.unsplash.com/photo-1523413651479-597eb2da0ad6",
    label: "Image 4",
  },
  {
    url: "https://images.unsplash.com/photo-1523413651479-597eb2da0ad6",
    label: "Image 1 From Server",
    fileId: "a543a4a5-5198-4dd2-b258-fc8e34aba0f6",
  },

  {
    url: "https://images.unsplash.com/photo-1523413651479-597eb2da0ad6",
    label: "Image 2 From Server",
    fileId: "425154b1-cfed-4709-90c6-4b3dd03b9025",
  },
];

export const tableModelList = [
  {
    id: 1,
    label: "Model 1",
    data: initialTableData,
    formId: "f36944b6-478e-41e8-b9c5-fde7c79eb9f4",
    typeFormId: "AGGREGATION",
  },
  {
    id: 2,
    label: "Model 2",
    data: initialTableData,
    formId: "",
    typeFormId: "",
  },
];
